<template>
  <div class="column pt-0">
    <TranslationPhraseModal
      :is-visible.sync="modalVisible"
      :phrase="selectedPhrase"
      @saved="onSaved"
      @close="selectedPhrase = null"
    />
    <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
      <h2 class="has-text-weight-semibold is-size-5 mb-0">Фразы переводов</h2>
      <b-button type="is-info" @click="openCreate">Добавить</b-button>
    </div>
    <BaseTable
      :data="phrases"
      :columns="columns"
      :loading="isLoading"
      :total="total"
      :per-page="perPage"
      :current-page="currentPage"
      @change="fetchPhrases"
      @rowClick="onRowClick"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/Base/Table";
import TranslationPhraseModal from "@/components/Dictionary/TranslationPhraseModal.vue";

export default {
  name: "DictionaryView",
  components: { BaseTable, TranslationPhraseModal },
  data() {
    return {
      total: 0,
      phrases: [],
      isLoading: true,
      currentPage: 1,
      perPage: 15,
      modalVisible: false,
      selectedPhrase: null,
      columns: [
        { field: "id", label: "ID", width: "60", numeric: true },
        { field: "key", label: "Ключ" },
        { field: "lang_code", label: "Язык" },
        { field: "value", label: "Значение" },
        { field: "category", label: "Категория" },
      ],
    };
  },
  mounted() {
    this.fetchPhrases();
  },
  methods: {
    async fetchPhrases(page) {
      this.currentPage = page || 1;
      this.isLoading = true;
      try {
        const offset = (this.currentPage - 1) * this.perPage;
        const { data } = await this.$axios.get(
          `admin/translation-phrases/paginate/${offset}/${this.perPage}`
        );
        this.phrases = data?.data || [];
        this.total = data?.count ?? 0;
      } catch (e) {
        throw new Error(e);
      }
      this.isLoading = false;
    },
    onRowClick(row) {
      this.selectedPhrase = row;
      this.modalVisible = true;
    },
    openCreate() {
      this.selectedPhrase = null;
      this.modalVisible = true;
    },
    onSaved() {
      this.selectedPhrase = null;
      this.fetchPhrases();
    },
  },
};
</script>

<style scoped>
</style>
